export enum TopicStatus {
    Active = 'active',
    Inactive = 'inactive',
}

export interface TopicCriterias {
    segment?: string[]
}

export interface Topic {
    id: string;
    title: string;
    description: string;
    benefits: string[];
    meta: any; // FIX ME!!!
    criterias: TopicCriterias;
    pictures: {
        default?: string;
        desktop?: string;
        mobile?: string;
    };
    status: TopicStatus;
    isPublic: boolean;
    dateCreated: Date;
    lastUpdated: Date;
    topicNumber: number;
}
